import dayjs from 'dayjs';
import { routes } from '../../../utils/constants/routes';

export type NewBookingUrlParams = {
  companyBranch?: string | number;
  companyMaster?: { value?: string | number } | string | number;
  contactedWith?: Array<{ value?: string | number }>;
};

const resolveParamValue = (value?: { value?: string | number } | string | number) => {
  if (value == null) {
    return '';
  }
  if (typeof value === 'object') {
    return value.value ?? '';
  }
  return value;
};

export const buildNewBookingUrl = (date: Date, urlParams?: NewBookingUrlParams) => {
  const search = new URLSearchParams({
    startDate: dayjs(date).format('YYYY-MM-DD'),
    endDate: dayjs(date).format('YYYY-MM-DD'),
  });

  if (urlParams?.companyBranch) {
    search.set('companyBranch', String(urlParams.companyBranch));
    search.set('companyMaster', String(resolveParamValue(urlParams.companyMaster)));
    search.set('contactedWith', String(urlParams.contactedWith?.[0]?.value ?? ''));
  }

  return `${routes.addBooking}?${search.toString()}`;
};
